export default __webpack_public_path__ + "app/images/bw-cs-leave.svg";